<script setup>
const { showEmptyMessage } = defineProps({
  showEmptyMessage: {
    type: Boolean,
    default() {
      return true;
    },
  },
});
const emits = defineEmits(["search"]);

const router = useRouter();

const isLoading = ref(false);

const keyword = ref("");
const items = ref([]);

const handleComplete = async (event) => {
  keyword.value = event.query;
  emits("search", event.query);
  await onSearchQuery(event.query);
};

const onSearchQuery = async (query) => {
  const { data } = await usePublicFetch("explore-search", {
    query: { keyword: query },
  });

  // Group data by type
  const groupedData = data?.value?.reduce((acc, item) => {
    const type = item.type;
    if (!acc[type]) {
      acc[type] = {
        label: type.charAt(0).toUpperCase() + type.slice(1), // Capitalize first letter
        items: [],
      };
    }
    acc[type].items.push({
      label: item.name,
      value: item.id,
      slug: item.slug,
      type: type,
    });
    return acc;
  }, {});

  // Convert grouped data to array format
  items.value = Object.values(groupedData || {});
};

const onSelect = (e) => {
  switch (e.value.type) {
    case "university":
      router.push(`/universities/${e.value.slug}`);
      break;
    case "program":
      router.push(`/programs/${e.value.slug}`);
      break;
    case "scholarship":
      router.push(`/scholarships/${e.value.slug}`);
      break;
    default:
      break;
  }
};
const currentRoute = useRoute();
const handleSearch = (event) => {
  if (isLoading.value) return;

  // Get value directly from input element because data is still updating in life cycle
  const searchValue = event.target.value;

  let queryString = [];
  queryString.push(`keyword=${encodeURIComponent(searchValue)}`);
  const query = queryString.length > 0 ? "?" + queryString.join("&") : "";

  if (currentRoute.path === "/explore") {
    if (searchValue.trim()) {
      navigateTo({
        path: "/explore",
        query: {
          ...currentRoute.query,
          keyword: searchValue,
        },
      });
    } else {
      const { keyword: _, ...restQuery } = currentRoute.query;
      navigateTo({
        path: "/explore",
        query: restQuery,
      });
    }
  } else {
    navigateTo(`/explore${query}`);
  }
};
</script>

<template>
  <AutoComplete
    name="explore-search"
    v-model="selectedItem"
    :suggestions="items"
    optionLabel="label"
    optionGroupLabel="label"
    optionGroupChildren="items"
    placeholder="Search by Uni, Program and Study Area"
    fluid
    size="small"
    class="w-full lg:px-0 lg:w-80 my-2 lg:h-12"
    @complete="handleComplete"
    @option-select="onSelect"
    @blur="onBlur"
    @keydown.enter="handleSearch"
    :showEmptyMessage="showEmptyMessage"
  >
    <template #header v-if="items.length > 0">
      <p class="text-sm p-2 mx-2 text-muted">
        Press
        <code
          class="px-1 py-0.5 border border-gray-50 bg-gray-100 rounded shadow-sm"
          >enter</code
        >
        to search in explore.
      </p>
    </template>
    <template #empty>
      <p class="text-sm mx-2 text-muted">
        Press
        <code
          class="px-1 py-0.5 border border-gray-50 bg-gray-100 rounded shadow-sm"
          >enter</code
        >
        to search in explore.
      </p>
    </template>
  </AutoComplete>
</template>
